module.exports = __webpack_public_path__ + "efbf8fc52c9186c720cdb298d4afc6a0.pdf";